import React, { useEffect, useRef } from "react";
import { Typography, Divider, Stack, Grid, useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";
import ImageBGComponent from "../commoncomponents/ImageBGComponent";
import CellmaFlexPremiumHome from "../../assets/images/CellmaFlexPremiumHome.png";
import CommonLayout from "../commoncomponents/layout/CommonLayout";
import Button from "@mui/material/Button";
import classes from "../../component/homepremium/HomePremium.module.css";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { getRequest, cellmaflexUrl } from "../../api/AxiosAPICall";
import HomePremiumData from "./HomePremiumData.json";
import telemedicineEasyAccess1 from "../../assets/images/Telemedicine-Easy Access-01.png";
import telemedicineEasyAccess2 from "../../assets/images/Telemedicine-Easy Access-02.png";
import telemedicineEasyAccess3 from "../../assets/images/Telemedicine-Easy Access-03.png";
import telemedicineEasyAccess4 from "../../assets/images/Telemedicine-Easy Access-04.png";

const HomePremium = () => {
  const isMounted = useRef<any>();
  const location = useLocation();
  const isLargeScreen = useMediaQuery("(min-width: 900px)");

  let jwtToken: any;
  if (localStorage.getItem("token") != null) {
    jwtToken = localStorage.getItem("token");
  }

  useEffect(() => {
    isMounted.current = false;
    const singoutHandler = async () => {
      await getRequest("logoutUser", {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });

      localStorage.removeItem("token");
      window.location.reload();
    };
    if (jwtToken !== undefined && jwtToken !== "") {
      singoutHandler();
    }

    return () => {
      isMounted.current = true;
    };
  }, [location, jwtToken]);

  const getImageSrc = (id: any) => {
    switch (id) {
      case "1":
        return telemedicineEasyAccess1;
      case "2":
        return telemedicineEasyAccess2;
      case "3":
        return telemedicineEasyAccess3;
      default:
        return telemedicineEasyAccess4;
    }
  };

  return (
    <CommonLayout
      footer={true}
      showHeaderNavigation={true}
      isLogedIn={true}
      cellmaflexUrl={cellmaflexUrl}
    >
      <Box>
        <ImageBGComponent
          title="Better Outcomes. Better Care. A Healthier You."
          description="Cellmaflex helps you book GP appointments, order repeat prescriptions and access local health services and benefits from anywhere anytime."
          image={CellmaFlexPremiumHome}
          imageText="main image description"
        />
      </Box>
      <Box>

        <Grid container direction="row">
          <Grid item md={12} xs={12}>
            <Typography
              component="div"
              className={classes.headingH2}
              gutterBottom
              sx={{
                fontSize: { xs: "22px", sm: "24px" },
                marginTop: { xs: "20px" },
              }}
            >
              Why Go Cellma<i>flex</i>?
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row">
          {HomePremiumData.map((item) => (
            <Grid
              item
              md={3}
              sm={6}
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "row",
                textAlign: "center",
                padding: {xs:"14px 50px", sm:"14px"},
                marginBottom: "16px",
              }}
              key={item.id}
            >
              <Box>
                  <img
                    src={getImageSrc(item.id)}
                    alt="CellmaFlexPremium"
                  />
                <Typography
                  variant={"h5"}
                  component="div"
                  sx={{
                    fontSize: "18px !important",
                    fontWeight:"550 !important",
                    color: "#117CB1 !important",
                    marginBottom: "12px !important",
                    textTransform: "uppercase",
                    "&:hover": {
                      borderBottom: "1px solid #46bcec !important",
                      borderWidth: "1 !important",
                    },
                  }}
                >
                  {item.heading}
                </Typography>
                <Typography
                  component="div"
                  sx={{
                    fontSize: "15px !important",
                    color: "#6d6e6e  !important",
                  }}
                >
                  {item.description}
                </Typography>
              </Box>
              {(isLargeScreen && item.id!=="4") && (
              <Divider
                orientation="vertical"
                style={{
                  height: "141px",
                  backgroundColor: "#000000", // Divider color
                }}
              />
              )}
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box className={classes.topSectionStyle}>
        <Grid container direction="row">
          <Grid item md={12} xs={12} className={classes.lineHeight}>
            <Typography variant="h1" className={classes.headingH1}>
              Get the Freemium Version for Free
            </Typography>
            <Stack
              className={classes.buttonStyle}
              spacing={1}
              direction={{ xs: "column", sm: "row", md: "row"}}
            >
              <Button
                component={RouterLink}
                to="/ViewPremiumPlans"
                onClick={() => window.scrollTo(0, 0)}
                className={classes.viewplansBtn}
                variant="contained"
              >
                View Plans
              </Button>
              <Button
                className={classes.getstartedbannerBtn}
                variant="contained"
                component={RouterLink}
                to="/organization"
              >
                Get Started
              </Button>
            </Stack>
            <Typography
              variant="body1"
              component="p"
              className={classes.termsConditionStyle}
            >
              Terms and conditions apply*
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </CommonLayout>
  );
};

export default HomePremium;
